import { countryCodeEmoji } from 'country-code-emoji';

/**
 * Convert emoji to hex codepoints for Twemoji CDN filename
 * Example: '🇺🇸' -> '1f1fa-1f1f8'
 */
function emojiToCodepoint(emoji) {
  return Array.from(emoji).map(char => {
    var _char$codePointAt;
    return (_char$codePointAt = char.codePointAt(0)) == null ? void 0 : _char$codePointAt.toString(16);
  }).filter(Boolean).join('-');
}
export default function getFlagEmojiUrl(countryCode) {
  if (!countryCode) return null;
  const flagEmoji = countryCodeEmoji(countryCode);
  if (!flagEmoji) return null;
  const basename = emojiToCodepoint(flagEmoji);
  return "https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/72x72/".concat(basename, ".png");
}
flarum.reg.add('fof-geoip', 'common/util/getFlagEmojiUrl', getFlagEmojiUrl);